import React from "react";
import { Gift } from "lucide-react";
import { PROMOS } from "../data/products";

export const PromoBanner = () => {
  if (!PROMOS.starterKit.enabled) return null;
  return (
    <div
      data-testid="promo-banner"
      className="bg-sage-100 text-charcoal-600 text-xs sm:text-sm py-2 border-b border-sage-200/60"
    >
      <div className="container-x flex items-center justify-center gap-2.5 flex-wrap">
        <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-sage-400 text-white shrink-0">
          <Gift className="w-3 h-3" strokeWidth={2.4} />
        </span>
        <span className="font-medium tracking-tight">
          {PROMOS.starterKit.publicText}
        </span>
      </div>
    </div>
  );
};

export default PromoBanner;
